import { Chart, ChartAttrs, ChartMeasure, ChordLine, ChordSection, LyricSection } from "~/shared/types/chart";

export class ChartMaker {
  private chord_section_template: ChordSection = {
    label: null,
    note: null,
    lines: Array(2).fill(null).map(
      (): ChordLine => ({
        note: null,
        measures: Array(2).fill(null).map((): ChartMeasure => ({ beats: ['', ''] }))
      })
    )
  }

  private lyric_section_template: LyricSection = {
    label: null,
    text: null
  }

  newChordSection = (): ChordSection => structuredClone(this.chord_section_template)
  newLyricSection = (): LyricSection => structuredClone(this.lyric_section_template)

  // for a full new chart, use the server endpoint
}
